import React from "react";
const PopupMessage = (props) => {
  return (
    <>
      <div className="popup-overlay ">
        <div className="popup-warp">
          <div className="popup-inner">
            <div className="icon-popup"></div>
            <h3 className="name-popup">Thông báo</h3>
            <div
              className="content-popup"
              dangerouslySetInnerHTML={{ __html: props.content }}
            ></div>
            {props.nameBtn2 && props.nameBtn1 && !props.groupBtnBlock && (
              <div className="group-btn-inline">
                <button
                  type="button"
                  className="btn btn-primary btn-border btn-block"
                  onClick={props.clickAction1}
                  dangerouslySetInnerHTML={{ __html: props.nameBtn1 }}
                ></button>
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={props.clickAction2}
                  dangerouslySetInnerHTML={{ __html: props.nameBtn2 }}
                ></button>
              </div>
            )}
            {props.nameBtn2 && props.nameBtn1 && props.groupBtnBlock && (
              <div className="btn-wrapper">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={props.clickAction3}
                  dangerouslySetInnerHTML={{ __html: props.nameBtn1 }}
                ></button>
                <button
                  type="button"
                  className="btn btn-primary btn-block  btn-border"
                  onClick={props.clickAction4}
                  dangerouslySetInnerHTML={{ __html: props.nameBtn2 }}
                ></button>
              </div>
            )}
            {props.nameBtn && (
              <button
                type="button"
                className="btn btn-primary btn-block"
                onClick={props.clickAction}
                dangerouslySetInnerHTML={{ __html: props.nameBtn }}
              ></button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupMessage;
